import React from 'react'

const StatsSection: React.FC = () => {
  return (
    <div className="py-16 bg-gradient-to-r from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Trusted by South Africans
          </h2>
          <p className="text-xl text-gray-600">
            Join the community that's revolutionizing tyre shopping
          </p>
        </div>

        <div className="max-w-sm mx-auto">
          <div className="text-center group hover:transform hover:scale-105 transition-all duration-300">
            <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200 group-hover:shadow-xl">
              <div className="text-4xl mb-4">👥</div>
              <div className="text-3xl font-bold text-blue-600 mb-2">
                Many
              </div>
              <div className="text-lg font-semibold text-gray-900 mb-1">
                Happy Customers
              </div>
              <div className="text-sm text-gray-600">
                South Africans saving money on tyres
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StatsSection
